export default __webpack_public_path__ + "static/media/0x6a3e7c3c6ef65ee26975b12293ca1aad7e1daed2.cdd5cf7e.webp";